import { IconPayments } from '~/design-system';
import type { ModuleDefinition } from '~/platform/registry/types';

export const paymentsModule: ModuleDefinition = {
  id: 'payments',
  i18nNamespace: 'payments',
  requires: { subject: 'payment', action: 'read' },

  nav: {
    labelKey: 'payments:nav',
    icon: IconPayments,
    to: 'payments',
    group: 'money',
    order: 20,
  },

  routes: [{ path: 'payments', component: () => import('./PaymentsPage') }],

  commands: [
    {
      id: 'payments.record',
      labelKey: 'payments:recordPayment',
      groupKey: 'payments:title',
      requires: { subject: 'payment', action: 'create' },
      run: ({ businessSlug, navigate }) => navigate(`/b/${businessSlug}/payments?new=1`),
    },
    {
      id: 'payments.debtors',
      labelKey: 'payments:receivable',
      groupKey: 'payments:title',
      run: ({ businessSlug, navigate }) => navigate(`/b/${businessSlug}/payments`),
    },
  ],
};
